// // ================================================================================
// // front-page.js
// // フロントページ用のスクリプトファイル
// // ================================================================================

// // Import
// // --------------------------------------------------------------- //


// // DOM Read for Vanilla
// // --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// gsap.registerPlugin(ScrollTrigger);

	if (!window.matchMedia("(min-width: 782px)").matches) return;

	// コンテナ要素とリストアイテムを取得
	const container = document.querySelector('.front-about-bg');
	const wrapper   = document.querySelector('.front-about'); // ここを追加
	const items     = document.querySelectorAll('.front-about-lists__item');
	if (!container || !wrapper || items.length === 0) return;

	// コンテナの top / height を保持する変数
	let containerTop    = 0;
	let containerHeight = 0;

	// 最後のアイテム高さ分の padding-bottom をセットする関数
	const setPaddingBottom = () => {
		const lastItem = items[items.length - 1];
		const lastHeight = lastItem.getBoundingClientRect().height;
		wrapper.style.paddingBottom = `${lastHeight}px`;
	};

	// コンテナの位置・高さを再計算する関数
	const updateMeasurements = () => {
		const rect = container.getBoundingClientRect();
		containerTop    = rect.top + window.scrollY;
		containerHeight = rect.height;
		setPaddingBottom();  // 再計算タイミングで padding も更新
	};

	// リサイズ時に再計算＆初回実行
	window.addEventListener('resize', updateMeasurements);
	updateMeasurements();

	// まず全アイテムの active を外して、最初だけ付与
	items.forEach(i => i.classList.remove('active'));
	items[0].classList.add('active');

	// スクロール量に応じて active を切り替える関数
	const updateActiveItem = () => {
		if (containerHeight === 0) return;  // 高さゼロなら何もしない

		const scrollY        = window.scrollY;
		const relativeScroll = scrollY - containerTop;
		let activeIndex      = 0;

		if (relativeScroll > 0) {
		const interval = containerHeight / items.length;
		activeIndex = Math.floor(relativeScroll / interval);
		activeIndex = Math.max(0, Math.min(activeIndex, items.length - 1));
		}

		items.forEach((item, idx) =>
		item.classList.toggle('active', idx === activeIndex)
		);
	};

	// もし <img> が中にあれば、ロード完了後に一度だけ再計算＋更新
	const img = container.querySelector('img');
	if (img && !img.complete) {
		img.addEventListener('load', () => {
		updateMeasurements();
		updateActiveItem();
		});
	}

	// スクロールイベントで更新
	window.addEventListener('scroll', updateActiveItem, { passive: true });

	// 最後に一度だけ実行
	updateActiveItem();

	const frontSlide = new Swiper('.js-front-slide', {
		loop: true,
		effect: 'fade',
		speed: 3000,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	});

} );






